<!--
Коментар.
1. Завдяки :key="route.fullPath" Page переванажується при зміні url.
2. Коли Page обирається деревом об'єктів d-setup-tree (CustomerSidebar),
    через url передається id об'єкта, якого обслуговує підвантажена сторінка
3. Завдяки v-if="route" Page  відкривається, коли роутер завершив маршрутизацію
   і сторінка здатна вичитати id об'єкта, який її ініціював
4. Загальні статичні довідники, які потрібні різним сторінкам, є сенс завантажувати тут
    і
-->

<template>
    <el-config-provider :locale="uk">
        <div class="admin-layout"
            :class="{'without-header': isAuthRoute}">
            <MainHeader
                v-if="!isAuthRoute"
                :activeChapter="curChapter"
                @selectedChapter="onSelectedChapter"
            />
            <div class="main-container">
                <CateringSidebar v-if="!isAuthRoute && curChapter === 'catering'" 
                :setNoPage="setNoPage"
                :chapter="curChapter"
                />
                <CustomersSidebar v-if="!isAuthRoute && curChapter === 'customers'"
                :setNoPage="setNoPage"
                :chapter="curChapter"
                />
                <main class="admin-layout__content" v-if="!noPage">
                    <img class="preloader rotate" 
                    style = "display:none"
                    src="/src/assets/img/preloader.png" 
                    />
                    <router-view v-if="route" :key="route.fullPath"/> 
                    <!-- <router-view :key="$route.fullPath" /> -->
                </main>
            </div>
        </div>
    </el-config-provider>
    <FloatingButton v-if="!isAuthRoute" />
</template>

<script setup>
import { computed, ref, provide, watch} from 'vue'
import { useRoute, useRouter } from 'vue-router'
import MainHeader from '@/components/MainHeader.vue'
import CateringSidebar  from '@/components/CateringSidebar.vue'
import CustomersSidebar  from '@/components/CustomersSidebar.vue'
import FloatingButton from '@/components/AiAssistant/FloatingButton.vue'
import uk from '@/locale/uk.js'

//глобальна змінна зберігає id поточної конфігурації з таблиці dSetupTree
const configId = ref(0)
provide('configId', configId)

const noPage = ref(false)
function setNoPage(val){ noPage.value = val }
const route = useRoute()
const router = useRouter()
const curChapter = ref("catering")
const isAuthRoute = computed(() => route.path === '/auth' || route.path === '/preauth' || route.path === '/')

const SECTION_ROOT = {
    catering: '/catering',
    customers: '/customers',
    revision: '/revision',
    report: '/report',
}

function chapterByRoute(routeValue) {
    const p = routeValue.path
    if (p.startsWith('/customers')) return 'customers'
    if (p.startsWith('/revision')) return 'revision'
    if (p.startsWith('/report')) return 'report'
    if (p.startsWith('/catering')) return 'catering'
    if (
        p === '/fClients' ||
        p === '/menu' ||
        p === '/lunches' ||
        (p === '/orders' && routeValue.query?.id)
    ) return 'customers'
    return 'catering'
}

function onSelectedChapter(chapter) {
    configId.value = null
    const target = SECTION_ROOT[chapter] || '/catering'
    if (route.path !== target) router.push(target)
}

watch(
    () => route.fullPath,
    () => {
        if (!isAuthRoute.value) {
            curChapter.value = chapterByRoute(route)
        }
    },
    { immediate: true }
)

</script>

<style lang="scss">

.rotate{
    animation-name: rotation;
    animation-duration: 2s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes rotation {
    100% {transform:rotate(360deg)}
    0% {transform:rotate(0deg)}
}


.el-overlay.is-message-box{
	z-index: 3001 !important;
}

.el-message{
	z-index: 6000 !important;
}

.admin-layout {
    display: flex;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
    .main-container {
        display: flex;
        overflow: hidden;
        min-width: 0;
        height: calc(100vh - 1px);
        .admin-layout__content {
            padding: 10px;  
            position: relative;
            min-width: 0;
            overflow: hidden;
            .preloader{
                position: absolute;
                left: calc(50% - 150px);
                top:15%;
                width: 300px;
                height: 300px;
                z-index: 3002;
            }
        }
    }
    &.without-header {
        .main-container {
            height: calc(100vh - 0px);
        }
    }
    &__content {
        flex: 1;
        padding: 0 10px 0 25px;
        /*overflow-y: auto;*/
    }
}
.pageLayout{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    position: relative;
}


:root{
    --el-overlay-color-lighter:#c0c0c075;
    --el-text-color-regular:rgb(90, 90, 90);
    --el-text-color-primary:rgb(90, 90, 90);
    --el-border-color:silver;
    --el-scrollbar-bg-color:var(--el-text-color-secondary);
    --el-scrollbar-opacity:0.3;
}

* {
    scrollbar-color: color-mix(in srgb, var(--el-scrollbar-bg-color) 30%, transparent) transparent;
    scrollbar-width: thin;
}
*::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}
*::-webkit-scrollbar-thumb {
    background-color: color-mix(in srgb, var(--el-scrollbar-bg-color) 30%, transparent);
    border-radius: 3px;
}
*::-webkit-scrollbar-track {
    background: transparent;
}




/* form input style */

.el-form {
    width: 100%;
    &-item {
        margin-bottom: 15px;
        &__label{
            height: 24px;
            line-height: 24px;
            font-size: 12px;
        }
        &__content{
            line-height: 24px;
            color:var(--el-text-color-regular);
        }
    }
}

.el-input{
    &--small{
        font-size: 14px;   
    }
    .el-input{
        &__inner{
            font-family: 'mainfont';
        }
        &.el-date-editor{
            height: 24px;
            border-color: gray;
        }
        &__suffix-inner span{
            color:gray;
            cursor:pointer;
            width: 15px;
        }
    }
}


.el-checkbox{
    height: 20px;
    margin-right: 0;
    &__inner{
        border-color: gray;
    }
    &__input.is-checked+.el-checkbox__label{
        color: inherit !important;
    }
    &.el-checkbox--small .el-checkbox__label {
    font-size: 14px;
    }
}


.el-select__wrapper{
    min-height: 24px;
    padding: 4px 2px 4px 10px;
}


.el-radio{
    height: 20px;
        &__inner{
        border-color: gray;
    }
    &__input.is-checked+.el-radio__label{
        color: inherit !important;
    }
    &.el-radio--small .el-radio__label{
        font-size: 14px;
    }
}

 .el-tag__content{
    color: var(--el-text-color-regular);
 }

.el-time-panel__footer {
    .el-time-panel__btn {
        font-size: 0;
        &:first-child::before {
            content: "✖";
            font-size: 13px;
            color:gray;
        }
        &:last-child::before {
            content: "✔";
            font-size: 16px;
        }
    }
}

.el-dialog{
    box-shadow: 3px 3px  silver;
    border-radius: 0;
    &__header.show-close{
        border-bottom: 1px solid orange;
        padding-bottom: 0;
    }
    &__title{
        font-size:14px;
    }
}

.el-popper{
    box-shadow: 3px 3px  silver;
    border-radius: 0;
}
.el-color-dropdown__link-btn {
    display: none !important;
}

.blocked {
   
    .el-input__wrapper, .el-select__wrapper{
    background-color: rgb(237, 237, 237);
    pointer-events: none;
    }
    
    .el-select__caret {
        display: none;
    }
    
}
/*
.DDTreeSelector{
	z-index: 3000;
    border-top: 15px solid white;
    box-shadow: 8px 8px 7px 0 grey;
    position: absolute;
    bottom: 290px;
    right: -9px;
    width: 100%;
    height: calc(100vh - 453px);
    transform: translate(-10px, -15px);
    transition: transform 0.5s ease-in-out;
    background-color: white;
    padding: 0 10px 10px 10px;
    box-sizing: border-box;

	.el-overlay{
		display: none;
	}
    header{
        text-align: right;
        line-height: 24px;
        font-weight: bold;
        font-size: 12px;
        &>span{
            color: red;
            font-weight: bold;
            font-size: 16px;
            margin-left: 10px;
            cursor: pointer;
        }
    }
}
*/
</style>
